import React, { useState, useEffect } from "react";
import { Button, Card, Text, Icon, Divider } from "@shopify/polaris";
import {
  GetAppPermissions,
  PermissionStatus,
  getAppOverViewDetails,
} from "../../dev_services/developer/api";
import { useParams } from "react-router-dom";
import SubmitPermissionDialog from "../../../developers_module/dev_components/submit_permission_dialog/submit_permssion_dialog";
import { InfoIcon } from "@shopify/polaris-icons";
import "../dev_permissions/dev_permission.scss"
interface ModuleData {
  module: string;
  module_id: string;
  description: string;
  list_of_permissions: Permission[];
}

interface Permission {
  id: string;
  name: string;
  description: string;
  access: string;
}

interface Props {
  moduleData: ModuleData[];
}
export default function DevPermission() {
  const [data, setData] = useState([]);
  //   const [showRequestAccess, setShowRequestAccess] = useState(false); // State to control rendering of the RequestAccessComponent
  const [selectedPermissionId, setSelectedPermissionId] = useState(""); // State to hold selected permission id
  const [selectedModuleID, setSelectedModuleId] = useState("");
  const [selectedModuleName, setSelectedModuleName] = useState(""); // State to hold selected module name
  const [selectedPermissionDescription, setSelectedPermissionDescription] =
    useState("");
  const [requestSentMap, setRequestSentMap] = useState({}); // State to track request status for each permission
  const [activePermissions, setActivePermissions] = useState<{
    [moduleName: string]: string[];
  }>({}); // State to hold active permissions module-wise

  const [selectedAppStatus, setSelectedAppStatus] = useState(""); // State to hold selected module name

  useEffect(() => {
    fetchData();
  }, []);
  const { appID } = useParams();

  const fetchData = async () => {
    try {
      const response = await getAppOverViewDetails(appID);
      const status = response.status;

      const apiData = await GetAppPermissions();
      setData(apiData);
      let APPstatus;
      if (status == "Draft") {
        APPstatus = "Active";
      } else if (status == "Reviewed") {
        APPstatus = "Inactive";
      } else if (status == "Submitted") {
        APPstatus = "Active";
      }
      setSelectedAppStatus(status);

      const permissionStatus = await PermissionStatus(APPstatus, appID);
      console.log("permissionSataus", permissionStatus);

      // Initialize the requestSentMap with default values
      const initialRequestSentMap = {};
      apiData.forEach((module) => {
        module.list_of_permissions.forEach((permission) => {
          initialRequestSentMap[permission.id] = false;
        });
      });
      setRequestSentMap(initialRequestSentMap);

      // Create a list of active permissions module-wise
      const activePermissionsList = {};
      permissionStatus.forEach((module) => {
        activePermissionsList[module.module] = module.list_of_permissions.map(
          (permission) => permission.id
        );
      });
      console.log("activePermissionsList", activePermissionsList);

      setActivePermissions(activePermissionsList);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const [selectedPermissions, setSelectedPermissions] = useState<string[]>([]); // Annotate the type as string[]

  const handleCheckboxChange = (permissionId: string) => {
    setSelectedPermissionId(permissionId);

    // Annotate the type of permissionId as string
    setSelectedPermissions((prevSelected) => {
      if (prevSelected.includes(permissionId)) {
        return prevSelected.filter((id) => id !== permissionId);
      } else {
        return [...prevSelected, permissionId];
      }
    });
  };

  const [dialogOpen, setDialogOpen] = useState(false); // State to manage the dialog open/close

  const handleCloseDialog = () => {
    setDialogOpen(false); // Close the dialog when needed
  };

  const handleRequestAccessSingle = (
    moduleName,
    module_id,
    permissiondescription,
    permissionId
  ) => {
    console.log("permission.id", permissionId);
    setDialogOpen(true);
    setSelectedPermissionId(permissionId);
    setSelectedPermissions([permissionId]);
    setSelectedModuleName(moduleName);
    setSelectedModuleId(module_id);
    setSelectedPermissionDescription(permissiondescription);
  };

  const handleRequestAccess = (
    moduleName,
    module_id,
    permissiondescription,
    permissionId
  ) => {
    // console.log("hi clicked");
    setDialogOpen(true);
    setSelectedPermissionId(permissionId);
    setSelectedModuleName(moduleName);
    setSelectedModuleId(module_id)
    setSelectedPermissionDescription(permissiondescription);
    // Get the active permissions for the module
    const activeModulePermissions = activePermissions[moduleName] || [];
    // Combine the selected permissions with the active permissions
    const combinedPermissions = [
      ...selectedPermissions,
      ...activeModulePermissions,
    ];
    // Set the combined permissions as the selected permissions
    setSelectedPermissions(combinedPermissions);
  };

  return (
    <>

      <div className="developer-page-frame permission-button" style={{ paddingTop: "25px", paddingLeft: "2.1rem", paddingRight: "2.1rem", paddingBottom: "20px" }}>
        <label style={{ fontFamily: "sfprobold", fontSize: "20px", lineHeight: "revert" }} className="font-medium text-base">
          API Access
        </label>
        {data.map((module: ModuleData, index) => (
          <div key={index} >



            <div className="mb-2" />

            {module.list_of_permissions.length > 1 ? (

              <Card>
                <div style={{ paddingBottom: "15px", fontFamily: "sfprobold", fontSize: "20px", lineHeight: "revert" }} className="font-medium text-base">
                  {module.module}
                </div>
                <div style={{ paddingBottom: "15px", fontFamily: "sfproregular", fontSize: "14px", lineHeight: "revert" }}>
                  {module.description}
                </div>
                {module.list_of_permissions.map((permission) => (
                  <div
                    key={permission.id}
                    style={{
                      marginBottom: "20px",
                      display: "flex",
                      cursor: "pointer",
                      position: "relative", // Set position to relative for positioning the "Selected" text
                    }}
                    onClick={() => handleCheckboxChange(permission.id)}
                  >
                    <div
                      style={{
                        width: "100%",
                        border: "1px solid #ccc",
                        borderRadius: "8px",

                        backgroundColor: activePermissions[module.module]?.includes(permission.id)
                          ? "#F1F8F5"
                          : selectedPermissions.includes(permission.id)
                            ? "#F1F8F5"
                            : "white",
                        position: "relative", // Set position to relative for positioning the "Selected" text
                      }}
                    >
                      <div style={{ padding: "20px", }}>
                        <label className="label-text">
                          {permission.access}
                        </label>
                      </div>
                      <Divider />
                      <div style={{ padding: "20px", }}>
                        <Text variant="bodyLg" as="p">
                          {permission.name}
                        </Text>
                        <Text variant="bodyLg" as="p">
                          {permission.description}
                        </Text>
                      </div>
                    </div>
                    {selectedPermissions.includes(permission.id) && (
                      <div
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          color: "green",
                          padding: "5px",
                          borderRadius: "5px",
                        }}
                      >
                        Selected
                      </div>
                    )}
                  </div>
                ))}
                {/* Common "Request Access" button */}
                <div style={{ marginTop: "20px" }}>
                  {activePermissions[module.module]?.length === module.list_of_permissions.length ? (
                    <>
                      <div>
                        <>
                          <div

                            style={{
                              width: "100%",
                              margin: "auto",
                              border: "1px solid #ccc",
                              borderRadius: "10px",
                              backgroundColor: "#D5EBFE",
                              padding: "10px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon source={InfoIcon} tone="base" />
                            <div style={{ display: "block", marginLeft: "15px" }}>
                              <Text variant="bodyLg" as="p">
                                Currently, this app is in sandbox mode, so you can access these permissions for testing purposes. It will only work for test accounts. Production accounts should only be used once the app is live.
                              </Text>
                            </div>
                          </div>
                        </>
                      </div>
                    </>
                  ) : (
                    <>
                      {selectedAppStatus === "Submitted" ||
                        activePermissions[module.module]?.length === module.list_of_permissions.length ? (
                        <>
                          <div>
                            <>
                              <div
                                className="container"
                                style={{
                                  width: "100%",
                                  margin: "auto",
                                  border: "1px solid #ccc",
                                  backgroundColor: "#D5EBFE",
                                  padding: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {/* <Icon source={InfoIcon} tone="base" /> */}
                                <div style={{ marginLeft: "15px" }}>
                                  <Text variant="bodyLg" as="p">
                                    This may take up to 7 business days. You will receive an email from our Developer Support team when your request has been processed.
                                  </Text>
                                </div>
                              </div>
                            </>
                          </div>
                        </>
                      ) : (
                        <>
                          <div >
                            <Button

                              onClick={() =>
                                handleRequestAccess(
                                  module.module,
                                  module.module_id,
                                  "",
                                  ""
                                )
                              }
                              disabled={
                                selectedAppStatus === "Submitted" ||
                                activePermissions[module.module]?.length === module.list_of_permissions.length
                              }
                            >
                              Request Access
                            </Button>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </Card>

            ) : (
              module.list_of_permissions.map((permission) => (
                <div key={permission.id} className="card-new">
                  <Card key={permission.id}>

                    <div style={{ padding: "20px" }} >
                      <label className="label-text ">
                        {permission.name}

                      </label>
                      <div style={{ paddingTop: "8px", fontFamily: "sfproregular", fontSize: "14px", lineHeight: "revert" }}>
                        {module.description}
                      </div>
                    </div>
                    <Divider />
                    <div style={{ padding:"20px",paddingTop: "10px" }}>
                      <label className="label-text" style={{ fontWeight: "500" }} >
                        {permission.description}
                      </label>
                    </div>
                    {activePermissions[module.module]?.includes(permission.id) ? (
                      <div >
                        <>
                          <div
                            className="container"
                            style={{

                              width: "100%",
                              margin: "auto",
                              border: "1px solid #ccc",
                              backgroundColor: "#D5EBFE",
                              padding: "20px",
                              borderRadius: "10px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon source={InfoIcon} tone="base" />
                            <div style={{ display: "block", marginLeft: "15px" }}>
                              <Text variant="bodyLg" as="p" >
                                Currently, this app is in sandbox mode, so you can
                                access these permissions for testing purposes. It
                                will only work for test accounts. Production
                                accounts should only be used once the app is live.
                              </Text>
                            </div>
                          </div>
                        </>
                      </div>
                    ) : (
                      <div style={{ padding: "20px" }}>
                        <Button
                          disabled={
                            selectedAppStatus === "Submitted" ||
                            activePermissions[module.module]?.length ===
                            module.list_of_permissions.length
                          }
                          onClick={() =>
                            handleRequestAccessSingle(
                              module.module,
                              module.module_id,
                              permission.description,
                              permission.id
                            )
                          }
                        >
                          Request Access
                        </Button>
                      </div>
                    )}

                    <SubmitPermissionDialog
                      open={dialogOpen}
                      onClose={handleCloseDialog}
                      permissionID={selectedPermissions}
                      moduleName={selectedModuleName}
                      moduleId={selectedModuleID}
                      description={selectedPermissionDescription}
                    />
                  </Card>
                </div>
              ))
            )}
          </div>
        ))}
      </div>
    </>
  );
}
